const theme = {
  main_theme: "#009265",
};

export default theme;
